import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchNewsOverview } from '../services/xmlService';
import './NewsPreview.css';

const NewsPreview = () => {
  const [newsArticles, setNewsArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    setLoading(true);
    setError(null);
    try {
      const news = await fetchNewsOverview();
      // Limitiere auf die neuesten 8 Artikel für die Vorschau
      setNewsArticles(news.slice(0, 8));
    } catch (err) {
      setError('News konnten nicht geladen werden.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('/');
    if (parts.length === 2) {
      const month = parseInt(parts[0]);
      const year = parts[1];
      const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 
                          'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
      if (month >= 1 && month <= 12) {
        return `${monthNames[month - 1]} ${year}`;
      }
    }
    return dateString;
  };

  if (loading) {
    return null;
  }

  if (error || newsArticles.length === 0) {
    return null;
  }

  return (
    <section className="news-preview">
      <div className="news-preview__container">
        <div className="news-preview__header">
          <h2 className="news-preview__title">Steuer News</h2>
          <p className="news-preview__subtitle">
            Aktuelle Informationen und Neuigkeiten aus dem Steuerrecht
          </p>
        </div>

        <div className="news-preview__scroll-container">
          <div className="news-preview__grid">
            {newsArticles.map((article) => (
              <Link
                key={article.id}
                to={`/news?article=${article.id}`}
                className="news-preview__card"
              >
                {article.image && (
                  <div className="news-preview__card-image-wrapper">
                    <img 
                      src={article.image} 
                      alt={article.title}
                      className="news-preview__card-image"
                      loading="lazy"
                    />
                  </div>
                )}
                
                <div className="news-preview__card-content">
                  {article.date && (
                    <span className="news-preview__card-date">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                      {formatDate(article.date)}
                    </span>
                  )}
                  
                  <h3 className="news-preview__card-title">{article.title}</h3>
                  
                  {article.teaser && (
                    <p className="news-preview__card-teaser">{article.teaser}</p>
                  )}
                  
                  <span className="news-preview__card-link">
                    Weiterlesen
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <Link to="/news" className="news-preview__all-link">
          Alle News ansehen
        </Link>
      </div>
    </section>
  );
};

export default NewsPreview;

